import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { globals } from "../../globals";
import { ConsultaCnpjModel } from "../../dominio/consulta-cnpj-model";
import { Observable } from "rxjs";
import { FontesConsultaCnpjModel } from "../../dominio/fontes-consulta-cnpj-model";

export interface FontesConsultaCnpjResponse {
  results: FontesConsultaCnpjModel[];
}

export interface ConsultaCnpjResponse {
  result: ConsultaCnpjModel;
}

@Injectable({
  providedIn: "root",
})
export class ConsultaCnpjService {
  constructor(private http: HttpClient) {}

  buscarFontes(): Observable<FontesConsultaCnpjResponse> {
    return this.http.get<FontesConsultaCnpjResponse>(
      `${globals.apiUrl}/api/v2/core/util/consultas-externas/cnpj/fontes`
    );
  }

  consultar(cnpj: string, idFonte: string | null = null): Observable<ConsultaCnpjResponse> {
    const consultaCnpjRequest = {
      cnpj: cnpj,
      idFonte: idFonte,
    };

    return this.http.post<ConsultaCnpjResponse>(
      `${globals.apiUrl}/api/v2/core/util/consultas-externas/cnpj/consultar`,
      consultaCnpjRequest
    );
  }
}
